import React from "react";
import { useNavigate } from "react-router-dom";
import { PageShell } from "../components/PageShell";
import { AppText, Button, Card, Medal } from "../components/ui";
import { Seo } from "../components/Seo";

/** Étape (b/c) à venir : paiement, espace membre, connexion, coach. Placeholder soigné. */
export default function ComingSoon({ title, description, cta }) {
  const navigate = useNavigate();
  return (
    <PageShell>
      <Seo title={title} description={description || title} noindex />
      <Card className="mt-8 flex flex-col items-center text-center gap-4 py-10">
        <Medal size={96} />
        <AppText variant="title">{title}</AppText>
        <AppText variant="body" className="text-km-ontertiary max-w-md">{description}</AppText>
        <div className="flex flex-col gap-2 w-full max-w-xs">
          <Button title="Faire mon profil (5 min)" onClick={() => navigate("/profil")} />
          <Button title="Retour à l'accueil" variant="secondary" onClick={() => navigate("/")} />
        </div>
      </Card>
    </PageShell>
  );
}
